var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.idTag.description.length > 0 ? _vm.idTag.description : "(keine Bezeichnung)")+" "),(_vm.hasPairedState)?_c('fa-icon',{class:['text-' + _vm.pairedIconColor, 'ms-1'],attrs:{"icon":_vm.pairedIcon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }